import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/api/api.service';
import { SalesChannel } from '../models/sales-channel.model';

@Injectable()
export class SalesChannelService {
   private apiService = inject(ApiService);

   domainName = 'SalesChannel';
   addedMessage = 'SalesChannelAdded';
   updatedMessage = 'SalesChannelUpdated';

   /** Inserted by Angular inject() migration for backwards compatibility */
   constructor(...args: unknown[]);

   constructor() {}

   get(id: string): Observable<SalesChannel> {
      return this.apiService.get(this.domainName, id);
   }

   getAll(): Observable<SalesChannel[]> {
      return this.apiService.getCustom(this.domainName + '/select');
   }

   save(obj: SalesChannel): Observable<any> {
      if (obj.Id && obj.Id.length > 0) {
         return this.apiService.put(this.domainName, obj, this.updatedMessage);
      } else {
         return this.apiService.post(this.domainName, obj, this.addedMessage);
      }
   }
}
